export default "/logos/fb33af8e495f90e52228f3bfc29611da.svg";